exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".is-trainee-selection{justify-content:space-around !important}.is-trainee-selection__column-big{flex-grow:1.1;padding-right:4px;padding-left:4px}.is-trainee-selection__column-small{flex-grow:1;padding-right:4px;padding-left:4px}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};